export default __webpack_public_path__ + "static/Group 85-8a4630231786984846c92fff46dfb631.jpg";